function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import React from "react";
import { ProgressBar } from "@blueprintjs/core";
export default (function (message, value, key, opts) {
  return window.toastr["default"]( /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 10
    }
  }, message), /*#__PURE__*/React.createElement(ProgressBar, {
    intent: value >= 1 ? "success" : "primary",
    animate: value < 1 || !value,
    stripes: value < 1 || !value,
    value: value
  })), _extends({
    timeout: value >= 1 ? 3000 : 100000,
    key: key
  }, opts));
});